import { createFeatureSelector, createSelector } from '@ngrx/store'
import { CityState } from './city.state'

export const selectCityState = createFeatureSelector<CityState>('city')

export const selectAllCities = createSelector(selectCityState, (state: CityState) => state.cities)
